// new js

/* ------------------------------------------------------------------
   Engraving preview: character limit + auto-fit text sizing
   - up to ENGRAVING_MAX_CHARS characters per line
   - shorter text renders bigger, longer text shrinks
   - both lines are always clamped to the preview square
------------------------------------------------------------------ */
var ENGRAVING_MAX_CHARS = 14;
var ENGRAVING_MIN_FONT_SIZE = 6;
/* Keeps glyphs off the engraved edge. These are ratios, not pixels, so the
   same safety margin holds on desktop, Android and iPhone where the preview
   square is rendered at different sizes. */
var ENGRAVING_WIDTH_RATIO = 0.9;
var ENGRAVING_HEIGHT_RATIO = 0.92;
// the face carries a moulded border - keep the text off it
var ENGRAVING_PLATE_INSET = 0.08;
// detected plate bounds per preview artwork, keyed by image src
var ENGRAVING_IMG_PLATES = {};
// the CSS box for the buckle preview is 500x500
var ENGRAVING_CANVAS_SIZE = 500;

// base = size used when a line is filled to ENGRAVING_MAX_CHARS
var ENGRAVING_LINES = {
    ".textline1": { base: 15, max: 34 },
    ".textline2": { base: 14, max: 28 }
};

function setEngravingBaseSize(selector, px) {
    if (ENGRAVING_LINES[selector]) {
        ENGRAVING_LINES[selector].base = px;
    }
}

function engravingBox($el) {
    var $box = $el.closest(".text-over_Convas");
    if ($box.length === 0) {
        $box = $el.parent();
    }
    return $box;
}

function engravingAvailableWidth($el) {
    var $box = engravingBox($el);
    var width = ($box.length && $box[0].clientWidth) || 0;
    if (width <= 0) {
        width = $el.parent().width() || $el.width() || 0;
    }
    return Math.max(0, width * ENGRAVING_WIDTH_RATIO);
}

// the CSS uses "font-size: Npx !important", so inline styles must be important too
function engravingSetFontSize($el, sizePx) {
    $el.each(function () {
        this.style.setProperty("font-size", sizePx + "px", "important");
        this.style.setProperty("line-height", "1.1", "important");
        this.style.setProperty("white-space", "nowrap", "important");
        this.style.setProperty("max-width", "100%", "important");
        // the stylesheet uses a fixed letter-spacing:2px, which dominates the
        // line once the text shrinks and stopped long names from ever fitting.
        // 0.06em matches the original spacing at the largest size and scales down.
        this.style.setProperty("letter-spacing", "0.06em", "important");
        $(this)
            .find("p")
            .each(function () {
                this.style.setProperty("font-size", sizePx + "px", "important");
                this.style.setProperty("letter-spacing", "0.06em", "important");
            });
    });
}

// shrinks both lines of one preview square until they fit vertically
function fitEngravingHeightIn(box) {
    if (!box || box.clientHeight <= 0) {
        return;
    }
    var $lines = $(box).find(".textline1, .textline2");
    if ($lines.length === 0) {
        return;
    }
    var budget = box.clientHeight * ENGRAVING_HEIGHT_RATIO;

    function contentHeight() {
        var total = 0;
        $lines.each(function () {
            total += this.offsetHeight || 0;
        });
        // fall back to scrollHeight when the lines report nothing usable
        return total > 0 ? total : box.scrollHeight;
    }

    var guard = 0;
    while (contentHeight() > budget && guard < 60) {
        var shrunk = false;
        $lines.each(function () {
            var size = parseFloat($(this).css("font-size")) || 0;
            if (size > ENGRAVING_MIN_FONT_SIZE) {
                engravingSetFontSize(
                    $(this),
                    Math.max(ENGRAVING_MIN_FONT_SIZE, size * 0.94)
                );
                shrunk = true;
            }
        });
        if (!shrunk) {
            break;
        }
        guard++;
    }
}

/* Measure against the real rendered width: the hidden probe under-estimates
   while a webfont is still loading, which left the text far smaller than the
   square could hold. Grow and shrink until the WIDEST line genuinely fills
   the box - every line keeps the same size. */
function engravingWidestLine($lines) {
    var widest = 0;
    $lines.each(function () {
        widest = Math.max(widest, this.scrollWidth);
    });
    return widest;
}

function fitEngravingLinesToWidth($lines, size, available, maxSize) {
    var guard = 0;
    engravingSetFontSize($lines, size);

    while (
        engravingWidestLine($lines) > available &&
        size > ENGRAVING_MIN_FONT_SIZE &&
        guard < 80
    ) {
        size = Math.max(ENGRAVING_MIN_FONT_SIZE, size - Math.max(0.2, size * 0.05));
        engravingSetFontSize($lines, size);
        guard++;
    }

    while (engravingWidestLine($lines) <= available && size < maxSize && guard < 160) {
        var next = Math.min(maxSize, size + Math.max(0.2, size * 0.04));
        if (next === size) {
            break;
        }
        engravingSetFontSize($lines, next);
        if (engravingWidestLine($lines) > available) {
            engravingSetFontSize($lines, size); // last size that still fitted
            break;
        }
        size = next;
        guard++;
    }
    return size;
}

/* Both lines are engraved at the SAME height, so one shared font size is used
   per preview square and the longest line decides it. */
function fitEngravingBox(box) {
    var $lines = $(box).find(".textline1, .textline2");
    if ($lines.length === 0) {
        return;
    }

    var sharedBase = 0;
    var sharedMax = 0;
    var longest = 1;
    var hasText = false;

    $lines.each(function () {
        var cfg =
            ENGRAVING_LINES[
            $(this).hasClass("textline1") ? ".textline1" : ".textline2"
            ] || { base: 14, max: 28 };
        sharedBase = Math.max(sharedBase, cfg.base);
        sharedMax = Math.max(sharedMax, cfg.max);

        var text = $.trim($(this).text());
        if (text !== "") {
            hasText = true;
            longest = Math.max(longest, text.length);
        }
    });

    longest = Math.min(longest, ENGRAVING_MAX_CHARS);

    if (!hasText) {
        engravingSetFontSize($lines, sharedBase);
        return;
    }

    // shorter name = bigger size (base is calibrated for a full line)
    var size = Math.max(
        ENGRAVING_MIN_FONT_SIZE,
        Math.min(sharedMax, sharedBase * Math.sqrt(ENGRAVING_MAX_CHARS / longest))
    );

    var available = Math.floor(engravingAvailableWidth($lines.first()));
    if (available <= 0) {
        // hidden preview (closed drawer): keep the computed size
        engravingSetFontSize($lines, Math.round(size * 10) / 10);
        return;
    }

    size = fitEngravingLinesToWidth($lines, size, available, sharedMax);
    engravingSetFontSize($lines, Math.round(size * 10) / 10);
    fitEngravingHeightIn(box);
}

/* The preview square is positioned with fixed pixels in the stylesheet
   (left:215px/top:285px/95x78, plus different hardcoded values per breakpoint),
   but the buckle canvas is rendered responsively. On any screen where the
   canvas is not exactly 500px the square drifts off the engraved plate, which
   is why the text ran past the buckle. Detect the plate in the canvas and place
   the square over it proportionally so it lines up on desktop, Android and iPhone. */
var ENGRAVING_PLATE = null;

function engravingMedian(values) {
    if (!values.length) {
        return null;
    }
    var sorted = values.slice().sort(function (a, b) {
        return a - b;
    });
    return sorted[Math.floor(sorted.length / 2)];
}

function engravingLongestRun(test, from, to) {
    var best = [0, -1];
    var start = null;
    for (var k = from; k < to; k++) {
        if (test(k)) {
            if (start === null) {
                start = k;
            }
        } else if (start !== null) {
            if (k - 1 - start > best[1] - best[0]) {
                best = [start, k - 1];
            }
            start = null;
        }
    }
    if (start !== null && to - 1 - start > best[1] - best[0]) {
        best = [start, to - 1];
    }
    return best;
}

function engravingRunContaining(test, from, to, anchor) {
    if (anchor === null || anchor < from || anchor >= to || !test(anchor)) {
        return null;
    }
    var start = anchor;
    var end = anchor;
    while (start - 1 >= from && test(start - 1)) {
        start--;
    }
    while (end + 1 < to && test(end + 1)) {
        end++;
    }
    return [start, end];
}

function detectEngravingPlate(canvas) {
    var W = canvas.width;
    var H = canvas.height;
    if (!W || !H) {
        return null;
    }
    var data;
    try {
        data = canvas.getContext("2d").getImageData(0, 0, W, H).data;
    } catch (err) {
        return null; // tainted canvas
    }

    // the engraved plate is the warm metal face of the buckle
    function gold(x, y) {
        var i = (y * W + x) * 4;
        return (
            data[i + 3] > 10 &&
            data[i] > 150 &&
            data[i + 1] > 135 &&
            data[i + 2] > 105 &&
            data[i] - data[i + 2] > 12
        );
    }

    var lefts = [];
    var rights = [];
    var widths = [];
    var rows = [];
    var xFrom = Math.round(W * 0.15);
    var xTo = Math.round(W * 0.85);
    var scanFrom = Math.round(H * 0.3);
    var scanTo = Math.round(H * 0.95);
    var rowRuns = {};

    for (var y = scanFrom; y < scanTo; y++) {
        var row = engravingLongestRun(
            (function (yy) {
                return function (x) {
                    return gold(x, yy);
                };
            })(y),
            xFrom,
            xTo
        );
        if (row[1] <= row[0]) {
            continue;
        }
        rowRuns[y] = row;
        // only the middle band is trusted for the median; above and below it
        // the frame and the strap are warm-toned too
        if (y >= H * 0.52 && y < H * 0.72) {
            lefts.push(row[0]);
            rights.push(row[1]);
            widths.push(row[1] - row[0]);
            rows.push(y);
        }
    }

    var medianWidth = engravingMedian(widths);
    if (!medianWidth || medianWidth < W * 0.08) {
        return null;
    }

    // drop rows that caught a highlight or the strap instead of the plate
    var keptLeft = [];
    var keptRight = [];
    var keptRows = [];
    for (var i = 0; i < widths.length; i++) {
        if (Math.abs(widths[i] - medianWidth) <= medianWidth * 0.2) {
            keptLeft.push(lefts[i]);
            keptRight.push(rights[i]);
            keptRows.push(rows[i]);
        }
    }

    var left = engravingMedian(keptLeft);
    var right = engravingMedian(keptRight);
    var anchorY = Math.round(engravingMedian(keptRows));
    if (left === null || right === null || right - left < W * 0.08) {
        return null;
    }

    /* Bound the band by the plate's own shape rather than by "is this pixel
       gold": the buckle frame and the closing mechanism below it are warm
       metal as well, so a colour-only scan ran past the engraved face and
       pushed the centred text down onto the catch. A row belongs to the face
       only while its gold run still matches the face's width and edges. */
    function faceRow(y) {
        var run = rowRuns[y];
        if (!run) {
            return false;
        }
        return (
            Math.abs(run[1] - run[0] - medianWidth) <= medianWidth * 0.18 &&
            Math.abs(run[0] - left) <= medianWidth * 0.15 &&
            Math.abs(run[1] - right) <= medianWidth * 0.15
        );
    }

    var band = engravingRunContaining(faceRow, scanFrom, scanTo, anchorY);
    if (!band) {
        return null;
    }
    var top = band[0];
    var bottom = band[1];
    if (bottom - top < H * 0.04) {
        return null;
    }

    /* Keep clear of the engraved border moulded around the face. */
    var inset = (bottom - top) * ENGRAVING_PLATE_INSET;
    top += inset;
    bottom -= inset;

    var plate = {
        left: left / W,
        right: right / W,
        top: top / H,
        bottom: bottom / H
    };
    // sanity guard: a believable plate never covers most of the image
    if (plate.right - plate.left > 0.7 || plate.bottom - plate.top > 0.6) {
        return null;
    }
    return plate;
}

/* The mobile drawer previews a different artwork (Engraving-collar-mobile.png)
   than the desktop canvas, so the plate sits elsewhere in the frame and the two
   cannot share one set of fractions. Detect per image and cache by src. */
function engravingPlateForImage(img) {
    var src = img.currentSrc || img.src;
    if (!src) {
        return null;
    }
    if (Object.prototype.hasOwnProperty.call(ENGRAVING_IMG_PLATES, src)) {
        return ENGRAVING_IMG_PLATES[src];
    }
    ENGRAVING_IMG_PLATES[src] = null; // in flight - do not queue a second probe

    /* The <img> in the page has no crossOrigin attribute, so drawing it would
       taint the canvas and block getImageData. Re-request it as anonymous:
       the CDN sends the right headers, which is how the desktop canvas works. */
    var probe = new Image();
    probe.crossOrigin = "anonymous";
    probe.onload = function () {
        var off = document.createElement("canvas");
        off.width = probe.naturalWidth;
        off.height = probe.naturalHeight;
        if (!off.width || !off.height) {
            return;
        }
        try {
            off.getContext("2d").drawImage(probe, 0, 0);
        } catch (err) {
            return;
        }
        var found = detectEngravingPlate(off);
        if (found) {
            ENGRAVING_IMG_PLATES[src] = found;
            fitEngravingLines();
        }
    };
    probe.src = src;
    return null;
}

function engravingPlateForTarget(target) {
    if (target.tagName === "CANVAS") {
        if (!ENGRAVING_PLATE) {
            ENGRAVING_PLATE = detectEngravingPlate(target);
        }
        return ENGRAVING_PLATE;
    }
    return engravingPlateForImage(target);
}

function engravingPreviewTarget(box) {
    var ref = (box.closest && box.closest(".canvas-wrapper")) || box.parentElement;
    if (!ref || !ref.querySelector) {
        return null;
    }
    var canvas = ref.querySelector("canvas");
    if (canvas) {
        return canvas;
    }
    // the mobile drawer shows a plain <img> instead of a canvas
    var best = null;
    var images = ref.querySelectorAll("img");
    for (var i = 0; i < images.length; i++) {
        var rect = images[i].getBoundingClientRect();
        if (rect.width && rect.height && (!best || rect.width > best[1])) {
            best = [images[i], rect.width];
        }
    }
    return best ? best[0] : null;
}

function positionEngravingBoxes() {
    $(".text-over_Convas").each(function () {
        var box = this;
        var parent = box.offsetParent;
        if (!parent) {
            return; // hidden preview, nothing to line up yet
        }
        var target = engravingPreviewTarget(box);
        if (!target) {
            return;
        }
        var plate = engravingPlateForTarget(target);
        if (!plate) {
            return; // leave the stylesheet's position until the plate is known
        }
        var rect = target.getBoundingClientRect();
        if (!rect.width || !rect.height) {
            return;
        }
        var parentRect = parent.getBoundingClientRect();

        box.style.setProperty(
            "left",
            rect.left - parentRect.left + plate.left * rect.width + "px",
            "important"
        );
        box.style.setProperty(
            "top",
            rect.top - parentRect.top + plate.top * rect.height + "px",
            "important"
        );
        box.style.setProperty(
            "width",
            (plate.right - plate.left) * rect.width + "px",
            "important"
        );
        box.style.setProperty(
            "height",
            (plate.bottom - plate.top) * rect.height + "px",
            "important"
        );
        // a breakpoint rule nudges the square with translateX(-51%)
        box.style.setProperty("transform", "none", "important");
    });
}

function fitEngravingLines() {
    reapplyEngravingFont();
    positionEngravingBoxes();

    $(".text-over_Convas").each(function () {
        fitEngravingBox(this);
    });

    // lines that live outside a .text-over_Convas square still need a size
    $(".textline1, .textline2").each(function () {
        if ($(this).closest(".text-over_Convas").length === 0) {
            fitEngravingBox(this.parentNode);
        }
    });
}

$(window).on("resize", fitEngravingLines);
$(window).on("load", fitEngravingLines);
$(document).ready(function () {
    showEngravingBuckle();
    observeEngravingLines();
    fitEngravingLines();
    // webfonts change metrics after load, so re-fit once they are ready
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(fitEngravingLines);
    }
    setTimeout(fitEngravingLines, 500);
    setTimeout(fitEngravingLines, 1500);
});

/* The buckle canvas is declared as width=500px height=500px. "500px" is not a
   valid integer attribute, so the canvas silently falls back to 300x150 and
   drawImage() only paints the blank top-left corner of the collar image.
   Make sure the canvas is visible and has real pixel dimensions. */
function showEngravingBuckle() {
    $(".canvas-container canvas, #imageCanvas").each(function () {
        if ($(this).css("display") === "none") {
            this.style.setProperty("display", "block", "important");
        }
        if (this.id === "canvasID") {
            return; // nested fallback canvas, not drawn on
        }
        if (this.width !== ENGRAVING_CANVAS_SIZE) {
            this.width = ENGRAVING_CANVAS_SIZE;
        }
        if (this.height !== ENGRAVING_CANVAS_SIZE) {
            this.height = ENGRAVING_CANVAS_SIZE;
        }
    });
}

$(window).on("resize load", showEngravingBuckle);
$(document).on("click", ".Engrave--btn, .free__engraving__wrapper", function () {
    setTimeout(showEngravingBuckle, 100);
});

// other scripts (new_custom.js mobile drawer) write these lines directly,
// so watch for content changes instead of relying on their handlers
function observeEngravingLines() {
    if (typeof MutationObserver === "undefined") {
        return;
    }
    var scheduled = false;
    var observer = new MutationObserver(function () {
        if (scheduled) {
            return;
        }
        scheduled = true;
        setTimeout(function () {
            scheduled = false;
            fitEngravingLines();
        }, 0);
    });
    $(".textline1, .textline2").each(function () {
        if ($(this).data("engravingObserved")) {
            return;
        }
        $(this).data("engravingObserved", true);
        observer.observe(this, {
            childList: true,
            characterData: true,
            subtree: true,
        });
    });
}

$(document).on(
    "click",
    ".Engrave--btn, .free__engraving__wrapper, .mobile_drw .radio_container input",
    function () {
        setTimeout(function () {
            observeEngravingLines();
            fitEngravingLines();
        }, 100);
    }
);

/* Requested: allow spaces in the name line.
   The markup carries an inline oninput handler:
       oninput="this.value = this.value.replace(/[^A-Za-z0-9\-]/g, '')"
   which strips the space on every keystroke (the phone line does the same with
   [^0-9\-]). Drop that attribute and sanitise here instead, keeping the same
   allow-list plus the space. */
function sanitizeEngravingValue(el) {
    var numeric =
        el.id === "line2" || el.id === "product-properties-number";
    var disallowed = numeric ? /[^0-9\- ]/g : /[^A-Za-z0-9\- ]/g;

    var caretSource = el.selectionStart;
    var start = typeof caretSource === "number" ? caretSource : el.value.length;
    var head = el.value.slice(0, start).replace(disallowed, "");
    var clean = el.value.replace(disallowed, "").slice(0, ENGRAVING_MAX_CHARS);

    if (clean === el.value) {
        return;
    }
    el.value = clean;
    var caret = Math.min(head.length, clean.length);
    try {
        el.setSelectionRange(caret, caret);
    } catch (err) { }
}

function allowSpacesInEngravingInputs() {
    $("#line1, #line2, #product-properties-name, #product-properties-number").each(
        function () {
            var el = this;
            if (el.engravingSpaceFix) {
                return;
            }
            el.engravingSpaceFix = true;

            // kill the inline handler that removes spaces
            el.removeAttribute("oninput");
            el.oninput = null;
            el.setAttribute("maxlength", ENGRAVING_MAX_CHARS);
            // the pattern attribute would fail validation on a space
            var pattern = el.getAttribute("pattern");
            if (pattern && pattern.indexOf(" ") === -1) {
                el.removeAttribute("pattern");
            }

            el.addEventListener("input", function () {
                sanitizeEngravingValue(el);
                $(el).trigger("keyup");
            });
        }
    );
}

$(document).ready(allowSpacesInEngravingInputs);

/* C23: preloading every selectable engraving font at ready/load pulled the
   Amatic and Indie Flower binaries plus the Google sheet that declares them
   into the critical window of every product page -- about 95KB fetched for a
   panel most visitors never open. The fonts are still fetched up front so a
   switch never shows a fallback, just after the page has gone idle, and the
   click handler below still forces them the moment the panel is opened. */
/* C61: the idle preload still fetched ~86KB of engraving fonts plus the Google
   sheet on every PDP, including ones with no visible engraving control. Wait
   until a trigger comes within 300px of the viewport (or is touched); the click
   handler below still forces the load for quick views. */
var ENGRAVING_TRIGGERS = ".Engrave--btn, .free__engraving__wrapper";

function ensureEngravingFontSheet() {
    var link = document.querySelector("link[data-sb-engrave-css]");
    if (link && !link.getAttribute("href")) {
        link.setAttribute("href", link.getAttribute("data-sb-engrave-css"));
    }
}

function schedulePreloadEngravingFonts() {
    if (schedulePreloadEngravingFonts.done) {
        return;
    }
    schedulePreloadEngravingFonts.done = true;
    var triggers = document.querySelectorAll(ENGRAVING_TRIGGERS);
    if (!triggers.length) {
        return;
    }
    if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) {
                if (entries[i].isIntersecting) {
                    io.disconnect();
                    idlePreloadEngravingFonts();
                    return;
                }
            }
        }, { rootMargin: "300px 0px" });
        for (var i = 0; i < triggers.length; i++) {
            io.observe(triggers[i]);
        }
        return;
    }
    idlePreloadEngravingFonts();
}

function idlePreloadEngravingFonts() {
    if (window.requestIdleCallback) {
        window.requestIdleCallback(function () {
            preloadEngravingFonts();
        }, { timeout: 4000 });
    } else {
        setTimeout(preloadEngravingFonts, 2500);
    }
}

$(document).ready(function () {
    selectDefaultEngravingFont();
});
$(window).on("load", function () {
    schedulePreloadEngravingFonts();
    selectDefaultEngravingFont();
});
// custom.js is usually injected after window load, so the handler above never fires
if (document.readyState === "complete") {
    schedulePreloadEngravingFonts();
}
$(document).on("pointerdown", ENGRAVING_TRIGGERS, function () {
    preloadEngravingFonts();
});
$(document).on("click", ".Engrave--btn, .free__engraving__wrapper", function () {
    setTimeout(allowSpacesInEngravingInputs, 100);
    setTimeout(function () {
        preloadEngravingFonts();
        // the popup clears every radio as it opens, so re-pick the default
        selectDefaultEngravingFont(true);
    }, 100);
});

/* The per-id switches below only know font_1 / font_2, so any other font radio
   never reached the preview. Apply the selected font generically, for every
   font radio on the page (desktop popup, drawer and mobile drawer). */
var ENGRAVING_ACTIVE_FONT = "";
var ENGRAVING_FONT_REQUEST = 0;

// the FontFace entries the page declares for a family (empty = system font)
function engravingFontFaces(fontName) {
    var faces = [];
    if (!document.fonts || !document.fonts.forEach) {
        return faces;
    }
    document.fonts.forEach(function (face) {
        if (face.family.replace(/^['"]|['"]$/g, "") === fontName) {
            faces.push(face);
        }
    });
    return faces;
}

/* document.fonts.check() is not usable here: for a family the page has not
   declared yet it resolves against system fallbacks and returns true, so the
   preload believed everything was ready before custom.css had even attached.
   Ask the FontFace objects for their real status instead. */
function engravingFontReady(fontName) {
    var faces = engravingFontFaces(fontName);
    if (!faces.length) {
        return true; // system font, or not declared - nothing to wait for
    }
    for (var i = 0; i < faces.length; i++) {
        if (faces[i].status === "loaded") {
            return true;
        }
    }
    return false;
}

/* Rendering real text in each family is the most reliable way to trigger the
   download: it does not depend on when the FontFace objects get registered,
   which matters because custom.css is attached lazily. The probes stay
   off-screen rather than display:none, since a hidden box loads no font. */
function engravingFontProbes(names) {
    var host = document.getElementById("engraving-font-preload");
    if (!host) {
        host = document.createElement("div");
        host.id = "engraving-font-preload";
        host.setAttribute("aria-hidden", "true");
        host.style.cssText =
            "position:absolute;left:-9999px;top:-9999px;width:0;height:0;" +
            "overflow:hidden;pointer-events:none;";
        (document.body || document.documentElement).appendChild(host);
    }
    for (var i = 0; i < names.length; i++) {
        var id = "engraving-font-probe-" + i;
        if (document.getElementById(id)) {
            continue;
        }
        var span = document.createElement("span");
        span.id = id;
        span.textContent = "ABCabc0123";
        span.style.cssText =
            'font-family:"' + names[i] + '";font-size:40px;font-weight:bold;';
        host.appendChild(span);

        var plain = span.cloneNode(true);
        plain.id = id + "-n";
        plain.style.fontWeight = "normal";
        host.appendChild(plain);
    }
}

// download every selectable font up front so switching never shows a fallback
function preloadEngravingFonts(attempt) {
    ensureEngravingFontSheet();
    if (!document.fonts || !document.fonts.load) {
        return;
    }
    attempt = attempt || 0;

    var names = [];
    var seen = {};
    $("input.font-selector").each(function () {
        var name = $(this).attr("value");
        if (name && !seen[name]) {
            seen[name] = true;
            names.push(name);
        }
    });

    engravingFontProbes(names);

    var incomplete = 0;
    for (var i = 0; i < names.length; i++) {
        var faces = engravingFontFaces(names[i]);
        var done = false;
        for (var j = 0; j < faces.length; j++) {
            if (faces[j].status === "loaded") {
                done = true;
            }
        }
        if (done) {
            continue;
        }
        incomplete++;
        try {
            document.fonts.load('16px "' + names[i] + '"');
            // the preview lines are bold, which is a separate face to fetch
            document.fonts.load('bold 16px "' + names[i] + '"');
        } catch (err) { }
    }

    /* custom.css is attached lazily (the theme swaps href for data-href), so on
       the first passes the @font-face rules may not exist yet and there is
       nothing to preload. Retry until every face is really loaded. */
    if ((incomplete > 0 || names.length === 0) && attempt < 40) {
        setTimeout(function () {
            preloadEngravingFonts(attempt + 1);
        }, 400);
    }
}

function applyEngravingFont(fontName) {
    if (!fontName) {
        return;
    }
    // a newer click must win, even if an older font resolves later
    var token = ++ENGRAVING_FONT_REQUEST;

    function commit() {
        if (token !== ENGRAVING_FONT_REQUEST) {
            return;
        }
        ENGRAVING_ACTIVE_FONT = fontName;
        // set as important so no stylesheet rule can win over the user's choice
        $(".textline1, .textline2").each(function () {
            this.style.setProperty("font-family", fontName, "important");
        });
        $(
            "#line1, #line2, #product-properties-name, #product-properties-number"
        ).css("font-family", fontName);
        fitEngravingLines();
    }

    if (engravingFontReady(fontName)) {
        commit();
        return;
    }

    /* The face is not in the cache yet. Swapping now would paint the fallback
       font for a few frames before the real one arrives, so keep the current
       font on screen and commit once the download finishes. */
    var settled = false;
    function once() {
        if (settled) {
            return;
        }
        settled = true;
        commit();
    }
    try {
        document.fonts
            .load('bold 16px "' + fontName + '"')
            .then(once)
            .catch(once);
    } catch (err) {
        once();
    }
    // never leave a choice unapplied if the font fails to load
    setTimeout(once, 800);
}

// the selected font is re-asserted on every fit, in case another script
// (theme.js / new_custom.js) overwrites font-family on the preview lines
function reapplyEngravingFont() {
    if (!ENGRAVING_ACTIVE_FONT) {
        return;
    }
    $(".textline1, .textline2").each(function () {
        if (this.style.fontFamily.indexOf(ENGRAVING_ACTIVE_FONT) === -1) {
            this.style.setProperty(
                "font-family",
                ENGRAVING_ACTIVE_FONT,
                "important"
            );
        }
    });
}

function engravingFontFromRadio($radio) {
    var value = $.trim($radio.val() || "");
    // font radios carry the family name; icon radios carry an image path
    if (!value || /^(https?:|\/\/|\/)/.test(value) || /\.(png|jpe?g|svg|gif|webp)/i.test(value)) {
        return "";
    }
    return value;
}

/* Nothing in the markup carries a checked attribute, and opening the popup
   clears every radio, so the font tiles rendered with no selection even though
   the preview was drawing in one of them. Pick a font and show it selected in
   every group - the popup and the mobile drawer mirror each other, so letting
   them diverge left one tile highlighted while the preview used the other. */
function selectDefaultEngravingFont(reset) {
    var radios = $("input.font-selector").toArray();
    if (!radios.length) {
        return;
    }

    var font = "";
    if (!reset) {
        // honour a choice already made before overriding it with the default
        for (var i = 0; i < radios.length; i++) {
            if (radios[i].checked) {
                font = engravingFontFromRadio($(radios[i]));
                if (font) {
                    break;
                }
            }
        }
    }
    if (!font) {
        font = engravingFontFromRadio($(radios[0]));
    }
    if (!font) {
        return;
    }

    var groups = {};
    for (var j = 0; j < radios.length; j++) {
        var group = radios[j].getAttribute("name") || "";
        if (!groups[group]) {
            groups[group] = [];
        }
        groups[group].push(radios[j]);
    }

    Object.keys(groups).forEach(function (group) {
        var members = groups[group];
        var match = null;
        for (var k = 0; k < members.length; k++) {
            if (engravingFontFromRadio($(members[k])) === font) {
                match = members[k];
            }
        }
        // a group without that font keeps its own first option selected
        var pick = match || members[0];
        for (var m = 0; m < members.length; m++) {
            members[m].checked = members[m] === pick;
        }
    });

    if (font !== ENGRAVING_ACTIVE_FONT) {
        applyEngravingFont(font);
    }
}

$(document).on("change click", 'input[type="radio"]', function () {
    var id = $(this).attr("id") || "";
    var name = $(this).attr("name") || "";
    var inFontGroup =
        $(this).closest(".engraving-fonts, .engraving-font, .font-selection").length > 0;
    if (!/font/i.test(id) && !/font/i.test(name) && !inFontGroup) {
        return; // icon radios and unrelated selectors keep their own behaviour
    }
    var fontName = engravingFontFromRadio($(this));
    if (!fontName) {
        return;
    }
    applyEngravingFont(fontName);
});

// if a font is already checked on page load, show it in the preview
$(document).ready(function () {
    var $checked = $('.engraving-fonts input[type="radio"]:checked').first();
    if ($checked.length === 0) {
        $checked = $('input[type="radio"][id*="font"]:checked').first();
    }
    if ($checked.length > 0) {
        var fontName = engravingFontFromRadio($checked);
        if (fontName) {
            applyEngravingFont(fontName);
        }
    }
});

$(document).ready(function () {
    $('.engraving-fonts input[type="radio"]').on("change", function (e) {
        if ($(this).prop("checked") == true) {
            var fontName = $.trim($(this).val());
            if (
                typeof fontName != "undefined" &&
                fontName != null &&
                fontName != ""
            ) {
                if ($("#product-properties-name").length > 0) {
                    $("#product-properties-name").css("font-family", fontName);
                    $("#product-properties-name").css("letter-spacing", "4px");
                    $("#product-properties-name").css("font-size", "20px");
                }
                if ($("#product-properties-number").length > 0) {
                    $("#product-properties-number").css("font-family", fontName);
                    $("#product-properties-number").css("letter-spacing", "2px");
                    $("#product-properties-number").css("font-size", "20px");
                }
            }
        }
    });

    $('.engraving-fonts input[type="radio"]').on("click", function (e) {
        if ($(this).hasClass("already-checked")) {
            $(this).prop("checked", true);
        } else {
            $('.engraving-fonts input[type="radio"]').removeClass("already-checked");
            $(this).addClass("already-checked");
        }
    });

    // ADD TO CART

    // $(".custom-add-to-cart-button").on("click", function(e) {
    //   setTimeout(function(){
    //        e.preventDefault();
    //         var checkEngravingValue = true;
    //        var checkEngravinge = false;
    //        if ($('.engraving-fonts input[type="radio"]').length > 0) {
    //            // checkEngravingValue = false;
    //            $('.engraving-fonts input[type="radio"]').each(function(e) {
    //                if ($(this).prop("checked") == true) {
    //                     checkEngravingValue = true;
    //                    checkEngravinge = true;
    //                }
    //            });
    //        }
    //        if (checkEngravingValue) {
    //            if (checkEngravinge) {
    //                console.log(checkEngravinge);
    //                 var variantId = 43315726647513;
    //                $.ajax({
    //                    type: 'POST',
    //                    url: '/cart/add.js',
    //                    data: {
    //                        quantity: 1,
    //                        id: variantId
    //                    },
    //                    dataType: 'json',
    //                    success: function(data) {
    //                        console.log('succccccc 1');
    //                    }
    //                });
    //                // Paid Engraving End
    //            }
    //            // $(this).parents("form.product-form").submit();
    //            $('.add_to_cart_wrapper').removeClass('custom--engrave-added');
    //            $('.engraving--added').delay(1000).fadeOut();
    //            $('.Engrave--btn').delay(1500).fadeIn();
    //            $('.radio__selection--btn input[type="radio"]').prop('checked', false);
    //            $("#product-properties-name").val('');
    //            $("#product-properties-number").val('');
    //        } else {
    //            nameValue = $.trim($("#product-properties-name").val());
    //            numberValue = $.trim($("#product-properties-number").val());
    //            if ((typeof nameValue != "undefined" && nameValue != null && nameValue != "") || (typeof numberValue != "undefined" && numberValue != null && numberValue != "")) {
    //                $.fancybox.open({
    //                    src: '#engraving_popup_wrapper',
    //                    type: 'inline',
    //                    opts: {
    //                        afterShow: function(instance, current) {

    //                        },
    //                        touch: false,
    //                        clickSlide: false,
    //                        clickOutside: false,
    //                        baseClass: 'engraving_fancybox_wrapper',
    //                    }
    //                });
    //            } else {
    //                if (checkEngravinge) {
    //                    console.log(checkEngravingValue);

    //                     var variantId = 43315726647513;

    //                    $.ajax({
    //                        type: 'POST',
    //                        url: '/cart/add.js',
    //                        data: {
    //                            quantity: 1,
    //                            id: variantId
    //                        },
    //                        dataType: 'json',
    //                        success: function(data) {
    //                            console.log('succccccc 2');
    //                        }
    //                    });
    //                    // Paid Engraving End
    //                }
    //                // $(this).parents("form.product-form").submit();
    //            }
    //        }
    //      },600)
    //    });

    // END

    $(
        ".on-key-up-js, #line1, #line2, #product-properties-name, #product-properties-number"
    ).attr("maxlength", ENGRAVING_MAX_CHARS);

    // Every counter reads "n/ENGRAVING_MAX_CHARS". Refresh all of them because
    // #line1/#line2 copy their values into the drawer inputs via .val().
    function refreshEngravingCounters() {
        $(".on-key-up-js").each(function () {
            $(this)
                .next(".ch__counter")
                .text(($(this).val() || "").length + "/" + ENGRAVING_MAX_CHARS);
        });
    }
    refreshEngravingCounters();

    $(".on-key-up-js").on("keydown", function (e) {
        var full = ($(this).val() || "").length >= ENGRAVING_MAX_CHARS;
        var printable = e.key && e.key.length === 1 && !e.ctrlKey && !e.metaKey;
        var selected = this.selectionStart !== this.selectionEnd;
        if (full && printable && !selected) {
            e.preventDefault();
        }
    });
    $(".on-key-up-js").on("input keyup change", function () {
        $(this).next(".Error").hide();
        refreshEngravingCounters();
    });
    $("input[type='number'].on-key-up-js").on("input", function (e) {
        $(this).val(
            $(this)
                .val()
                .replace(/[^0-9]/g, "")
        );
    });

    // $(".coll-meta").each(function () {
    //   var per = $(this)
    //     .children(".content_div")
    //     .children(".product_data")
    //     .find("p.field_price")
    //     .attr("attr_pre");
    //   if (per == 0) {
    //     $(this).addClass("show_per");
    //   } else {
    //     $(this).removeClass("show_per");
    //   }
    // });
});

$(document).ready(function () {
    // Several handlers open/close the engraving UI, so watch the classes
    // instead of hooking each one. CSS uses this to hide floating widgets
    // (gift button, Omnisend, Rebuy) that otherwise cover Confirm on phones.
    var engravingPanels = document.querySelectorAll(
        ".engraving-slide-drawer, #engraving-popup"
    );
    function syncEngravingOpen() {
        var open = false;
        for (var i = 0; i < engravingPanels.length; i++) {
            var el = engravingPanels[i];
            var cl = el.classList;
            if (
                cl.contains("open__engraving") ||
                (cl.contains("active") && el.getClientRects().length > 0)
            ) {
                open = true;
            }
        }
        document.body.classList.toggle("sb-engraving-open", open);
    }
    if (engravingPanels.length && window.MutationObserver) {
        var engravingObserver = new MutationObserver(syncEngravingOpen);
        for (var j = 0; j < engravingPanels.length; j++) {
            engravingObserver.observe(engravingPanels[j], {
                attributes: true,
                attributeFilter: ["class"],
            });
        }
        syncEngravingOpen();
    }

    $(".Engrave--btn").click(function () {
        $(".engraving-slide-drawer").addClass("open__engraving");
    });
    const product__contentWraperOffset = $(".product__content--wrapper").offset()
    $("#engraving-cancel-btn").click(function () {
        $(".engraving-slide-drawer").removeClass("open__engraving");
        let offset = $(".product__content--wrapper").offset()
        if (product__contentWraperOffset != undefined){
            $("html,body").animate({
                scrollTop: product__contentWraperOffset.top,
            });
        }
    });
    $("#close-engraving-slide").click(function () {
        $(".engraving-slide-drawer").removeClass("open__engraving");
        console.log("dsssf");
        if (product__contentWraperOffset != undefined){
            $("html,body").animate({
                scrollTop: product__contentWraperOffset.top,
            });
        }

        //            $('body').removeClass("fixed-position");
    });
    $("#engraving-submit-btn").click(function () {
        var error = "This feild is required";
        let r1;
        let r2;
        let r3;
        var input1 = false;
        var input2 = false;
        var input3 = false;
        r1 = $('.engraving-fonts input[type="radio"]:checked').val();
        if (r1 === undefined || r1 === null || r1 === "") {
            console.log("engraving font is missing");
            $.fancybox.open({
                src: "#custom_engraving_popup_wrapper_font",
                type: "inline",
                opts: {
                    afterShow: function (instance, current) { },
                    touch: false,
                    clickSlide: false,
                    clickOutside: false,
                    baseClass: "engraving_fancybox_wrapper",
                },
            });
        } else {
            var input1 = true;
            $("#fontName").text("Font: " + r1);
        }
        r2 = $("#product-properties-name").val();
        if (r2 === undefined || r2 === null || r2 === "") {
            // $("#Name").hide();
            console.log("engraving name is missing");
            $.fancybox.open({
                src: "#custom_engraving_popup_wrapper_name",
                type: "inline",
                opts: {
                    afterShow: function (instance, current) { },
                    touch: false,
                    clickSlide: false,
                    clickOutside: false,
                    baseClass: "engraving_fancybox_wrapper",
                },
            });
        } else {
            var input2 = true;
            $("#Name").text("Name: " + r2);
        }
        r3 = $("#product-properties-number").val();
        if (r3 === undefined || r3 === null || r3 === "") $("#phone").hide();
        else {
            var input3 = true;
            $("#phone").text("phone Number: " + r3);
        }
        if (input1 && input2) {
            $(".engraving-slide-drawer").removeClass("open__engraving");
            //                $('body').removeClass("fixed-position");
            $(".Engrave--btn").hide();
            $(".add_to_cart_wrapper").addClass("custom--engrave-added");
            $(".engraving--added").show();
            if (product__contentWraperOffset != undefined){
              $("html,body").animate({
                  scrollTop: product__contentWraperOffset.top,
              });
            }
        } else {
            console.log("pls fill first");
        }
    });
    $("#product-properties-name").on("keydown keyup change", function (e) {
        $("#nameError").hide();
    });
    $("#product-properties-number").on("keydown keyup change", function (e) {
        $("#phoneError").hide();
    });
    $('.radio__selection--btn input[type="radio"]').change(function () {
        $("#fontError").hide();
    });

    $(".engrave--edit").click(function () {
        if ($(window).width() < 767) {
            // $(".engraving-slide-drawer").addClass("open__engraving");
        } else {
            // $("#engraving-popup").addClass("active");
        }
        //               $('body').addClass("fixed-position");
    });
    $(".engrave--remove").click(function () {
        $('.radio__selection--btn input[type="radio"]').prop("checked", false);
        $("#product-properties-name").val("");
        $("#product-properties-number").val("");
        $(".engraving--added").hide();
        $(".Engrave--btn").show();
        $(".desktop-engrave-bttn").show();
        $(".add_to_cart_wrapper").removeClass("custom--engrave-added");
    });
});

$(document).ready(function () {
    $(".faq__accordion .faq__toggle").click(function (e) {
        e.preventDefault();

        let $this = $(this);

        if ($this.next().hasClass("show_block")) {
            $this.next().removeClass("show_block");
            $this.next().slideUp(350);
        } else {
            $this.parent().parent().find("li .faq__inner").removeClass("show_block");
            $this.parent().parent().find("li .faq__inner").slideUp(350);
            $this.next().toggleClass("show_block");
            $this.next().slideToggle(350);
        }
    });
});

// /Dynamic Engraving
$(document).ready(function () {
    var imageLoader = document.getElementById("imageLoader");
    var canvas = document.getElementById("imageCanvas");
    if (!canvas) {
        return;
    }
    var ctx = canvas.getContext("2d");
    var img = new Image();
    img.crossOrigin = "anonymous";

    window.addEventListener("load", DrawPlaceholder);
    // if the script runs after window.load (cached/deferred), draw immediately
    if (document.readyState === "complete") {
        DrawPlaceholder();
    }

    function DrawPlaceholder() {
        img.onload = function () {
            DrawOverlay(img);
        };
        img.src =
            "https://cdn.shopify.com/s/files/1/0102/1437/5505/files/Engraving-collar-desktop.png?v=1670487212";
    }

    function DrawOverlay(img) {
        // the markup declares width=500px, which is an invalid integer attribute,
        // so the canvas would default to 300x150 and show only a blank corner
        if (canvas.width !== ENGRAVING_CANVAS_SIZE) {
            canvas.width = ENGRAVING_CANVAS_SIZE;
        }
        if (canvas.height !== ENGRAVING_CANVAS_SIZE) {
            canvas.height = ENGRAVING_CANVAS_SIZE;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // scale the collar to fit without distorting it
        var scale = Math.min(
            canvas.width / (img.naturalWidth || img.width || canvas.width),
            canvas.height / (img.naturalHeight || img.height || canvas.height)
        );
        var drawWidth = (img.naturalWidth || img.width) * scale;
        var drawHeight = (img.naturalHeight || img.height) * scale;
        ctx.drawImage(
            img,
            (canvas.width - drawWidth) / 2,
            (canvas.height - drawHeight) / 2,
            drawWidth,
            drawHeight
        );

        ctx.fillStyle = "rgba(30, 144, 255, 0.0)";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // a new buckle image means the engraved plate moved - re-detect it
        ENGRAVING_PLATE = null;
        fitEngravingLines();
    }

    function convertToImage() {
        window.open(canvas.toDataURL("png"));
    }

    $(".free__engraving__wrapper").click(function () {
        // only reset the typed lines - using .find('input').val('') also wiped
        // the value attribute of the font/icon radios, so no font could apply
        $("#engraving-popup")
            .find('input[type="text"], input[type="number"], input:not([type])')
            .val("")
            .trigger("keyup")
            .trigger("change");
        $("#engraving-popup")
            .find('input[type="radio"], input[type="checkbox"]')
            .prop("checked", false);
        $("#engraving-popup").addClass("active");
        showEngravingBuckle();
        fitEngravingLines();
    });
    $(".custom-engraving-popup__close").click(function () {
        $("#engraving-popup").removeClass("active");
    });
    $(".engraving-popup input[type=radio]").change(function () {
        let inputId = $(this).attr("id");
        console.log(inputId);
        let fontName = $.trim($(this).val());
        let imageSrc = $(this).parent().find("img").attr("src");

        switch (inputId) {
            case "select_font_1":
                $("#font_1").prop("checked", true);
                if (
                    typeof fontName != "undefined" &&
                    fontName != null &&
                    fontName != ""
                ) {
                    if ($(".textline1").length > 0) {
                        $(".textline1").css("font-family", fontName);
                        $(".textline1").css("letter-spacing", "2px");
                        setEngravingBaseSize(".textline1", 15);
                        $(".textline1").css("font-weight", "bold");
                    }
                    if ($(".textline2").length > 0) {
                        $(".textline2").css("font-family", fontName);
                        $(".textline2").css("letter-spacing", "2px");
                        setEngravingBaseSize(".textline2", 12);
                        $(".textline2").css("font-weight", "bold");
                    }
                    fitEngravingLines();
                }
                break;
            case "select_font_2":
                $("#font_2").prop("checked", true);
                if (
                    typeof fontName != "undefined" &&
                    fontName != null &&
                    fontName != ""
                ) {
                    if ($(".textline1").length > 0) {
                        $(".textline1").css("font-family", fontName);
                        $(".textline1").css("letter-spacing", "2px");
                        setEngravingBaseSize(".textline1", 20);
                        $(".textline1").css("font-weight", "600");
                    }
                    if ($(".textline2").length > 0) {
                        $(".textline2").css("font-family", fontName);
                        $(".textline2").css("letter-spacing", "2px");
                        setEngravingBaseSize(".textline2", 16);
                        $(".textline2").css("font-weight", "600");
                    }
                    fitEngravingLines();
                }
                break;
            case "select_icon_1":
            case "icon_1":
                $("#icon_1").prop("checked", true);
                $(".line-one-image").attr("src", imageSrc);
                $(".line-one-image").removeClass("hide");
                break;
            case "select_icon_2":
            case "icon_2":
                $("#icon_2").prop("checked", true);
                $(".line-one-image").attr("src", imageSrc);
                $(".line-one-image").removeClass("hide");
                break;
            case "select_icon_3":
            case "icon_3":
                $("#icon_3").prop("checked", true);
                $(".line-one-image").attr("src", imageSrc);
                $(".line-one-image").removeClass("hide");
                break;
            case "select_icon_4":
            case "icon_4":
                $("#icon_4").prop("checked", true);
                $(".line-one-image").attr("src", imageSrc);
                $(".line-one-image").removeClass("hide");
                break;
            case "select_icon_5":
            case "icon_5":
                $("#icon_5").prop("checked", true);
                $(".line-one-image").attr("src", imageSrc);
                $(".line-one-image").removeClass("hide");
                break;

            default:
                console.log("nothing");
        }
    });

    $(
        ".radio__selection--btn.js-selection .radio_container input[type=radio]"
    ).change(function () {
        let inputId = $(this).attr("id");
        console.log(inputId);
        let fontName = $.trim($(this).val());
        let imageSrc = $(this).parent().find("img").attr("src");
        switch (inputId) {
            case "font_1":
                if (
                    typeof fontName != "undefined" &&
                    fontName != null &&
                    fontName != ""
                ) {
                    if ($(".textline1").length > 0) {
                        $(".textline1").css("font-family", fontName);
                        $(".textline1").css("letter-spacing", "2px");
                        setEngravingBaseSize(".textline1", 15);
                        $(".textline1").css("font-weight", "bold");
                        $("#line1").css("font-family", fontName);
                        $("#line1").css("letter-spacing", "2px");
                        $("#line1").css("font-size", "15px");
                    }
                    if ($(".textline2").length > 0) {
                        $(".textline2").css("font-family", fontName);
                        $(".textline2").css("letter-spacing", "2px");
                        setEngravingBaseSize(".textline2", 14);
                        $("#line2").css("font-family", fontName);
                        $("#line2").css("letter-spacing", "2px");
                        $("#line2").css("font-size", "14px");
                        $(".textline2").css("font-weight", "bold");
                    }
                    fitEngravingLines();
                }
                break;
            case "font_2":
                if (
                    typeof fontName != "undefined" &&
                    fontName != null &&
                    fontName != ""
                ) {
                    if ($(".textline1").length > 0) {
                        $(".textline1").css("font-family", fontName);
                        $(".textline1").css("letter-spacing", "2px");
                        setEngravingBaseSize(".textline1", 15);
                        $("#line1").css("font-family", fontName);
                        $("#line1").css("letter-spacing", "2px");
                        $("#line1").css("font-size", "15px");
                        $("#line1").css("font-weight", "600");
                    }
                    if ($(".textline2").length > 0) {
                        $(".textline2").css("font-family", fontName);
                        $(".textline2").css("letter-spacing", "2px");
                        setEngravingBaseSize(".textline2", 14);
                        $("#line2").css("font-family", fontName);
                        $("#line2").css("letter-spacing", "2px");
                        $("#line2").css("font-size", "14px");
                        $("#line2").css("font-weight", "600");
                    }
                    fitEngravingLines();
                }
                break;
            default:
                console.log("nothing");
        }
    });

    $("#line1").on("keyup change", function (e) {
        let text_title = $(this).val().slice(0, ENGRAVING_MAX_CHARS);
        $("#product-properties-name").val(text_title);
        $(".textline1").text(text_title);
        fitEngravingLines();
    });
    $("#line2").on("keyup change", function (e) {
        let text_title = $(this).val().slice(0, ENGRAVING_MAX_CHARS);
        $("#product-properties-number").val(text_title);
        $(".textline2").text(text_title);
        fitEngravingLines();
    });
    $("#product-properties-name").on("keyup change", function (e) {
        let text_title = $(this).val().slice(0, ENGRAVING_MAX_CHARS);
        $(".textline1").text(text_title);
        fitEngravingLines();
    });
    $("#product-properties-number").on("keyup change", function (e) {
        let text_title = $(this).val().slice(0, ENGRAVING_MAX_CHARS);
        $(".textline2").text(text_title);
        fitEngravingLines();
    });

    $("#engraving-popup-submit").click(function () {
        // let checkSelectedFont = $(
        //   ".radio__selection--btn.engraving-fonts .radio_container input[type=radio]:checked"
        // );
        // let checkSelectedName = $(
        //   ".radio__selection--btn.engraving-fonts .radio_container input[type=radio]:checked"
        // );
        let fontValue = $('.engraving-fonts input[type="radio"]:checked').val();
        let nameValue = $("#product-properties-name").val();
        let numberValue = $("#product-properties-number").val();
        if (!fontValue) {
            $.fancybox.open({
                src: "#engraving_popup_wrapper",
                type: "inline",
                opts: {
                    afterShow: function (instance, current) { },
                    touch: false,
                    clickSlide: false,
                    clickOutside: false,
                    baseClass: "engraving_fancybox_wrapper",
                },
            });
        } else if (!nameValue && !numberValue) {
            $.fancybox.open({
                src: "#custom_engraving_popup_wrapper_name",
                type: "inline",
                opts: {
                    afterShow: function (instance, current) { },
                    touch: false,
                    clickSlide: false,
                    clickOutside: false,
                    baseClass: "engraving_fancybox_wrapper",
                },
            });
        } else {
            $("#engraving-popup").removeClass("active");
            $("#fontName").text("Font: " + fontValue);

            if (!nameValue) {
                $("#Name").hide();
            } else {
                $("#Name").text("Name: " + nameValue);
            }
            if (!numberValue) {
                $("#phone").hide();
            }
            else {
                $("#phone").text("phone Number: " + numberValue);
            }
            if (fontValue && (nameValue || numberValue)) {
                $(".desktop-engrave-bttn").hide();
                $(".add_to_cart_wrapper").addClass("custom--engrave-added");
                $(".engraving--added").show();
                const product__contentWraperOffset = $(".product__content--wrapper").offset()
                if (product__contentWraperOffset != undefined){
                    $("html,body").animate({
                        scrollTop: product__contentWraperOffset.top,
                    });
                }
            } else {
                console.log("pls fill first");
            }
        }
    });
});

// end here

// $(document).ready(function () {
//   $(".coll-meta:first-child").addClass("bundle_active");
//   $(".data_p .var_text:nth-child(1)").toggleClass("price_active");
//   $(".coll-meta").each(function () {
//     if ($(this).hasClass("bundle_active")) {
//       var top_check = "no-custom";
//       var check = $(this).attr("temp-name");
//       if (top_check == check) {
//         $(".btn_main_de").hide();
//       } else {
//         $(".btn_main_de").show();
//       }
//     }
//   });
// });

// $(".content_div").click(function () {
//   $(this).parent(".coll-meta").addClass("bundle_active");
//   $(this).parent(".coll-meta").siblings().removeClass("bundle_active");
//   var title = $(this).parent(".coll-meta").attr("data-match");
//   $(".data_p").each(function (index) {
//     var title_2 = $(this).attr("data-title");
//     if (title == title_2) {
//       $(this).css("display", "flex");
//       $(this).addClass("show_color");
//     } else {
//       $(this).removeClass("show_color");
//     }
//   });
//   var top_check = "no-custom";
//   var check = $(this).parents(".coll-meta").attr("temp-name");
//   if (top_check == check) {
//     $(".btn_main_de").hide();
//   } else {
//     $(".btn_main_de").show();
//   }

//   var cont_text = $(this).children(".product_data").find(".field_title").text();
//   var matc = $(".custom_btn").attr("attr_mtc");
//   if (cont_text == matc) {
//     $(".custom_btn").hide();
//   } else {
//     $(".custom_btn").show();
//   }
// });

// $(".var_text").click(function () {
//   $(this).parent(".data_p").removeClass("show_color");
//   $(this).addClass("price_active");
//   $(this).siblings().removeClass("price_active");
//   var $this = $(this);
//   $('.var_text[size="' + $this.text() + '"]').each(function () {
//     var vid_price = $(
//       '.coll-meta[pro_id="' + $(this).attr("pro_id_1") + '"] .field_price '
//     ).html($(this).attr("attr-price"));
//     $('.coll-meta[pro_id="' + $(this).attr("pro_id_1") + '"] p.cm_price').html(
//       $(this).attr("attr_com")
//     );
//     $(
//       '.coll-meta[pro_id="' + $(this).attr("pro_id_1") + '"] p.save_price'
//     ).html($(this).attr("attr_save"));
//     var title = $(this).attr("proti");
//     var mat = $(".coll-meta.bundle_active").attr("data-match");
//     if (title == mat) {
//       var qut = $(this).attr("quantitiy");
//       var qut1 = $(this).attr("quantitiy1");
//       console.log(qut);
//       if (qut1 < 1) {
//         $(".sold-meta").addClass("sold_show");
//         $(".add-products").attr("disabled", true);
//         $(".mobile_add").attr("disabled", true);
//         $(".add-products").addClass("sold_btn");
//         $(".mobile_add").addClass("sold_btn");
//       } else if (qut < 1) {
//         $(".sold-meta").removeClass("sold_show");
//         $(".add-products").attr("disabled", false);
//         $(".mobile_add").attr("disabled", false);
//         $(".add-products").removeClass("sold_btn");
//         $(".mobile_add").removeClass("sold_btn");
//       }
//     }
//   });
// });

// $(".row_meta .coll-meta").click(function () {
//   const sym = (currency, locale) =>
//     new Intl.NumberFormat(locale, { style: "currency", currency })
//       .formatToParts(1)
//       .find((x) => x.type === "currency").value;
//   var match_point = $(this).attr("data-match");
//   var active = $(".var_text.price_active").text();
//   var vid_price_se = $(
//     '.var_text[proti="' + match_point + '"][size="' + active + '"]'
//   ).attr("attr-price");
//   var price_main = $(".coll-meta.bundle_active")
//     .children(".content_div")
//     .find(".product_data")
//     .children(".field_price")
//     .text(sym(Shopify.currency.active) + (vid_price_se / 100).toFixed(2));
// });

// $('.coll-meta[data-match="Bundle"]').click(function () {
//   $(".new_collar").hide();
// });
// $('.coll-meta[data-match="Bowtie Collar & Leash Set"]').click(function () {
//   $(".new_collar").show();
// });
// $('.coll-meta[data-match="Mega Bundle"]').click(function () {
//   $(".new_collar").show();
// });

// $(".coll-meta").click(function () {
//   var coll_nnn = $(this).attr("data-match");
//   var part_nn = $(".col-btn-div .new_collar").attr("attr_na");
//   if (coll_nnn == part_nn) {
//     $(".col-btn-div .new_collar").hide();
//   } else {
//     $(".col-btn-div .new_collar").show();
//   }

//   var call_sw = $(".data_p .var_text.price_active").text();
//   $('.var_text[size="' + call_sw + '"]').each(function () {
//     var prop = $(".coll-meta.bundle_active").attr("data-match");
//     var min_t = $(this).attr("proti");
//     if (prop == min_t) {
//       var qut = $(this).attr("quantitiy");
//       var qut1 = $(this).attr("quantitiy1");
//       if (qut1 < 1) {
//         $(".sold-meta").addClass("sold_show");
//         $(".add-products").attr("disabled", true);
//         $(".mobile_add").attr("disabled", true);
//         $(".add-products").addClass("sold_btn");
//         $(".mobile_add").addClass("sold_btn");
//       } else if (qut < 1) {
//         $(".sold-meta").removeClass("sold_show");
//         $(".add-products").attr("disabled", false);
//         $(".mobile_add").attr("disabled", false);
//         $(".add-products").removeClass("sold_btn");
//         $(".mobile_add").removeClass("sold_btn");
//       }
//     }
//   });
// });

// $(".add-products").click(function () {
//   var sz = $(".var_text.price_active").text();
//   var name = $(".coll-meta.bundle_active").attr("data-match");
//   var vid = $('.var_text[proti="' + name + '"][size="' + sz + '"]').attr(
//     "var-id"
//   );
//   var fontname = $(".engraving--details.coll-details-part p#fontName")
//     .find(".text-co")
//     .text();
//   var name_q = $(".engraving--details.coll-details-part p#Name")
//     .find(".text-co")
//     .text();
//   var phone = $(".engraving--details.coll-details-part p#phone")
//     .find(".text-co")
//     .text();
//   var pro_id = $(this).attr("coll_nex");
//   var items = [];
//   items.push({
//     id: vid,
//     quantity: 1,
//     properties: { font: fontname, Name: name_q, PhoneNumber: phone },
//   });
//   if (
//     $(".last_div .full--width.engraving--added.mb-3").hasClass("add_products")
//   ) {
//     items.push({ id: pro_id, quantity: 1 });
//   } else {
//   }
//   console.log(vid);
//   $.ajax({
//     type: "POST",
//     url: "/cart/add.js",
//     data: { items: items },
//     dataType: "json",
//     success: function (response) {
//       console.log("success");
//       cart.getCart();
//     },
//     error: function () {
//       console.log("error");
//     },
//   });
// });

$(".hide_bb").click(function () {
    $(".opt-btn-new .full--width.engraving--added.mb-3").hide();
    $(".opt-btn-new .coll_btn .custom_btn").show();
});

// $(document).ready(function () {
//   var text = $(".var_text.price_active").text();
//   $('.var_text[size="' + text + '"]').each(function () {
//     var title = $(this).attr("proti");
//     var mat = $(".coll-meta.bundle_active").attr("data-match");
//     if (title == mat) {
//       var qut = $(this).attr("quantitiy");
//       var qut1 = $(this).attr("quantitiy1");
//       console.log(qut);
//       if (qut1 < 1) {
//         $(".sold-meta").addClass("sold_show");
//         $(".add-products").attr("disabled", true);
//         $(".add-products").addClass("sold_btn");
//         $(".mobile_add").attr("disabled", true);
//         $(".mobile_add").addClass("sold_btn");
//       } else if (qut < 1) {
//         $(".sold-meta").removeClass("sold_show");
//         $(".add-products").attr("disabled", false);
//         $(".mobile_add").attr("disabled", false);
//         $(".add-products").removeClass("sold_btn");
//         $(".mobile_add").removeClass("sold_btn");
//       }
//     }
//   });
// });

// $(".opt-btn-new .custom_btn").click(function () {
//   $(".opt-btn-new .engraving-slide-drawer").addClass("open_mb");
// });